import { Outlet } from "react-router";

import { TableColumnSettingsProvider } from "@providers/TableColumnSettingsProvider/TableColumnSettingsProvider";

import { OrganizationsCard } from "@components/Cards/OrganizationsCard/OrganizationsCard";
import { DEFAULT_ORGANIZATION_TABLE_COLUMN_SETTINGS } from "@components/Tables/OrganizationsTable/UI/OrganizationsTableColumns";

export const OrganizationsPage = () => {

  return (
    <TableColumnSettingsProvider
      tableId="organizations"
      defaultColumnSettings={DEFAULT_ORGANIZATION_TABLE_COLUMN_SETTINGS}
    >
      <OrganizationsCard />
      <Outlet />
    </TableColumnSettingsProvider>
  );
};
